
class GridListsContent {
    constructor() {
        this.init();
    }

    init() {
        if (document.querySelector('.js-card-lift-grid') !== null) {
            window.ListsContent.styleGridLists();
        }
    }
}

export default GridListsContent;
